import React from "react";
import Modal from 'react-modal';

const WalletModal = ({ modalIsOpen, setIsOpen, onWalletConnect, onMetamaskConnect }) => {
  function closeModal() {
    setIsOpen(false);
  }

  let injectedProvider = typeof window.ethereum !== 'undefined' ? true : false;

  // Get current URL path
  const currentPath = window.location.pathname;

  const modalClassName = (currentPath === '/ufo' || currentPath === '/ufo-pools' || currentPath === '/ufo-reward' || currentPath === '/ufo-statistics') 
  ? 'UFOSEC My__Overlay' 
  : 'My__Overlay';



  return (
    <>
      <Modal
        className="modalWallet"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Wallet Modal"
      >
        <div className={modalClassName}>
          <div className="My__OverlayIn">
            <div className="container">
              <div className="bottomModal">
                <div className="popupcenter">
                  <div className="d-flex justify-content-end borderclose SRTOP closepopup closepopupWallet">
                    <button onClick={closeModal} className="nobg d-flex align-items-center gap-1">
                      <span className="underline">Close</span>
                      <img className="img-fluid" alt="close" src="./images/XCircle.svg" />
                    </button>
                  </div>
                  <div className="modalBody">
                    <div className="row">
                      {injectedProvider && (
                        <div className="col bordercol">
                          <button className="nobg w-100" onClick={onMetamaskConnect}>
                            <div className="snstakes statsALL SRTOP">
                              <div className="relative">
                                <div className="t">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="iconSRWallet">
                                      <img className="img-fluid m-0" src="./walletimg/metamask.png" />
                                    </div>
                                    <div>
                                      <div className="mybtn underline text-white">
                                        <span>Click Here</span>
                                        <img className="img-fluid m-0" src="./images/ArrowCircleUpRight.svg" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="statBottom">
                                    <h2 className="fHead text-start">MetaMask or Trust Wallet</h2>
                                    <div className="perVal fInter d-flex align-items-center">
                                      <span>Popular</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </button>
                        </div>
                      )}
                      <div className="col bordercol">
                        <button className="nobg w-100" onClick={onWalletConnect}>
                          <div className="snstakes statsALL SRTOP">
                            <div className="relative">
                              <div className="t">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="iconSRWallet">
                                    <img className="img-fluid" src="./walletimg/walletconnect-logo.png" />
                                  </div>
                                  <div>
                                    <div className="mybtn underline text-white">
                                      <span>Click Here</span>
                                      <img className="img-fluid m-0" src="./images/ArrowCircleUpRight.svg" />
                                    </div>
                                  </div>
                                </div>
                                <div className="statBottom">
                                  <h2 className="fHead text-start">WalletConnect</h2>
                                  <div className="perVal fInter d-flex align-items-center" style={{ opacity: '0' }}>
                                    <span>Popular</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div> {/* end modalClassName */}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WalletModal;
